import React from "react";
import "../../styles/ComponentsStyles/Universal/TableCard.style.css";
const TableCard = ({ title, tableHead = [], children, count }) => {
  return (
    <div className="tableCard">
      <div
        className="w-full flex-row align-center justify-between"
        style={{ height: "3rem" }}
      >
        <h3 className="weight-500 poppins t-20 color-grayColor">{title}</h3>
        {count !== false && (
          <p className="t-12 poppins-medium color-greenColor">
            {children && children.length + " person"}
          </p>
        )}
      </div>
      <div className="flex-1  w-full scroll-y">
        <table className="tableCardTable">
          <thead>
            <tr>
              {tableHead &&
                tableHead.map((head) => (
                  <th style={{ width: `${100 / tableHead.length}%` }}>
                    {head}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody className="scroll-y">{children}</tbody>
        </table>
      </div>
    </div>
  );
};

export default TableCard;
